import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { HeaderService } from '../header/header.service';
import { Offcanvas } from '../form.offcanvas';
import { ScriptLoader } from '../script-loader';
import { GroupService } from '../groups/groups.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BrandService } from '../brand/brand.service';
declare var $: any;

/**
 * Modern UI re-skin of DashboardComponent (src/app/dashboard).
 * Business logic, API calls, and permission/condition gating are ported 1:1 -
 * only presentation (markup/styling, no jQuery DataTables/Bootstrap tabs) differs.
 */
@Component({
  selector: 'app-dashboard-v2',
  templateUrl: './dashboard-v2.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../_crop/css/style.css',
    './../../_crop/css/style-example.css',
    './dashboard-v2.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DashboardService, LoginService, HeaderService, Offcanvas, ScriptLoader, GroupService]
})
export class DashboardV2Component implements OnInit, OnDestroy {

  brand = this.brandService.brand;
  constructor(private dashboardservice: DashboardService, private router: Router,
    private loginservice: LoginService, private headerservice: HeaderService, private offcanvas: Offcanvas,
    private scriptLoader: ScriptLoader, private groupservice: GroupService, private translate: TranslateService,
    private brandService: BrandService) {
    this.schoolCountryCode = this.brandService.brand.defaultCountryDialCode || '91';
  }

  public static gAcademicId = 0;
  private langChangeSubscription: any;

  getAuthToken: any;
  getSchoolId: any;

  endDateDatePicker = new Date();
  schoolCurrency = 'INR';
  schoolCountryCode: string;
  public schoolMatrices;
  totalBroadcast;
  totalStudents;
  totalStaffs;
  totalClasses;
  // No "last broadcast sent" date exists in dashboardMetrices today — left
  // undefined (not fabricated) until that field is added to the API
  // response; the template's *ngIf keeps the subheading hidden until then.
  lastBroadcastLabel: string | undefined;
  totalRegStudents = 0;
  lengthRegStudentsArray = 0;
  regAverage = 0;
  adminPermissionlist: any;
  studentRegistration = [[0, 0]];
  regTickValue = [[0, '']];

  activeStaffAppUser = 0;
  inActiveStaffAppUser = 0;
  activeParentAppUser = 0;
  inActiveParentAppUser = 0;
  staffAppAdoptionPercent = 0;
  parentAppAdoptionPercent = 0;

  recentBroadcast = [];
  isApproved = false;
  isFranchise: any;

  loaderMetrics = true;

  readonly skeletonRows = Array.from({ length: 5 }, () => ({}));

  activeTab: 'admissions' | 'schoolStatus' | 'onlinePayments' | 'appStatus' = 'admissions';

  admissionByStatus = true;
  paymentHistoryByStatus = true;

  getNewAdmissionListArray = [];
  getDateAdmission = 0;
  admissionDateFilter = '';

  noresultadmission = true;
  loaderadmission = true;
  fkFranchiseId: any;

  admissionPageSize = 10;
  admissionPage = 1;

  getSchoolStatusListArray = [];
  getschoolStatusDate;
  schoolActivityDateFilter = '';
  loaderactivity = true;

  schoolStatusPageSize = 10;
  schoolStatusPage = 1;

  todayDate;
  viewActivityTotalStudent;
  viewActivityAttendence;
  viewActivityFeesCollected = 0;
  viewActivityDiaries;
  viewActivityTeacher1;
  viewActivityTeacher2;
  viewActivityTeacher3;
  showActivityDetail = false;
  activityDetailTab: 'overview' | 'activities' = 'overview';

  getgetClassFeedListArray = [];
  feedCount = false;

  parentAppAndroidVersion;
  staffAppAndroidVersion;
  onlineFeeCollection = [];
  onlineFeeSingleDate = '';
  onlineFeeStartDate = '';
  onlineFeeEndDate = '';

  getSchoolName;
  getSchoolImage;
  getSchoolState;
  getSchoolLocality;
  accountType;
  onlinePaymentHistory = 'DISABLED';
  permissions: any = {};
  schoolActivityDataInCall = false;
  loginMode = '';
  adminType: any;
  viewActivityClassNumber = '';
  viewActivityClassSection = '';
  feesModuleSettingsDetails: any;
  staffName = '';

  schoolCategories = [];
  selectedCategory = '0';
  selectedSection = '0';
  schoolClasses = [];
  selectClassStatus = true;
  schoolClassesSections = [];
  selectClassSectionStatus = true;
  selectedClass = '0';

  get admissionCategoryLabel(): string | null {
    const match = this.schoolCategories.find((c: any) => `${c.categoryId}` === `${this.selectedCategory}`);
    return match ? match.categoryName : null;
  }

  get admissionClassLabel(): string | null {
    const match = this.schoolClasses.find((c: any) => `${c.classid}` === `${this.selectedClass}`);
    return match ? match.classname : null;
  }

  get admissionSectionLabel(): string | null {
    const match = this.schoolClassesSections.find((c: any) => `${c.claaSectionId}` === `${this.selectedSection}`);
    return match ? match.classSection : null;
  }

  get hasAdmissionFilters(): boolean {
    return !!(this.selectedCategory && this.selectedCategory !== '0')
      || !!(this.selectedClass && this.selectedClass !== '0')
      || !!(this.selectedSection && this.selectedSection !== '0');
  }

  clearAdmissionFilters() {
    this.selectClassStatus = true;
    this.selectClassSectionStatus = true;
    this.schoolClasses = [];
    this.schoolClassesSections = [];
    this.selectedCategory = '0';
    this.selectedClass = '0';
    this.selectedSection = '0';
    this.getNewAdmissionList();
  }

  // get school info
  getSchoolInfoFromHeader() {
    this.headerservice.schoolInfo(this.getSchoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.getSchoolName = data.schoolName;
          this.getSchoolImage = data.schoolImage;
          this.getSchoolState = data.state;
          this.getSchoolLocality = data.locality;
          this.accountType = data.accountType;
        },
        error => {
        }
      );
  }

  navigateTo(path, data) {
    this.router.navigate(['/' + path], { state: { tab: data } });
  }

  setActiveTab(tab: 'admissions' | 'schoolStatus' | 'onlinePayments' | 'appStatus') {
    this.activeTab = tab;
    if (tab === 'schoolStatus') {
      this.getSchoolActivityStatus();
    } else if (tab === 'onlinePayments') {
      this.getOnlineFeePayCollection(null);
    }
  }

  // New admission
  admissionByClick(getValue) {
    this.admissionByStatus = getValue;

    if (getValue === true) {
      this.getDateAdmission = 0;
      this.getNewAdmissionList();
    } else {
      this.selectClassStatus = true;
      this.selectClassSectionStatus = true;
      this.selectedCategory = '0';
      this.selectedClass = '0';
      this.selectedSection = '0';
    }
  }

  paymentHistoryByClick(getValue) {
    this.paymentHistoryByStatus = getValue;
  }

  getNewAdmissionList() {
    this.loaderadmission = true;
    this.getNewAdmissionListArray = [];
    const categoryId = (!this.selectedCategory || this.selectedCategory === '0') ? null : this.selectedCategory;
    const classStdId = (!this.selectedClass || this.selectedClass === '0') ? null : this.selectedClass;
    const classId = (!this.selectedSection || this.selectedSection === '0') ? null : this.selectedSection;
    let data = {
      schoolId: this.getSchoolId,
      date: this.getDateAdmission,
      categoryId,
      classStdId,
      classId
    };
    this.dashboardservice.fetchNewAdmissionList(data, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.loaderadmission = false;
          this.noresultadmission = data.newadmissionlist.length === 0;
          for (let i = 0; i < data.newadmissionlist.length; i++) {
            const item = data.newadmissionlist[i];

            const exists = this.getNewAdmissionListArray.some(existingItem =>
              existingItem.studentId === item.studentId
            );

            if (!exists) {
              this.getNewAdmissionListArray.push(item);
            }
          }
          this.admissionPage = 1;
        },
        error =>
          () => {
          }
      );
  }

  admissionSortColumn: 'registrationId' | 'dateOfAdmission' | null = null;
  admissionSortDirection: 'asc' | 'desc' = 'asc';

  sortAdmissionsBy(column: 'registrationId' | 'dateOfAdmission') {
    if (this.admissionSortColumn === column) {
      this.admissionSortDirection = this.admissionSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.admissionSortColumn = column;
      this.admissionSortDirection = 'asc';
    }
    this.admissionPage = 1;
  }

  get admissionTotalPages() {
    return Math.max(1, Math.ceil(this.getNewAdmissionListArray.length / this.admissionPageSize));
  }

  get sortedAdmissionList() {
    if (!this.admissionSortColumn) {
      return this.getNewAdmissionListArray;
    }
    const column = this.admissionSortColumn;
    const direction = this.admissionSortDirection === 'asc' ? 1 : -1;
    return [...this.getNewAdmissionListArray].sort((a: any, b: any) => {
      if (column === 'dateOfAdmission') {
        const aTime = new Date(a.dateOfAdmission).getTime();
        const bTime = new Date(b.dateOfAdmission).getTime();
        return (aTime - bTime) * direction;
      }
      const aValue = a.registrationId ?? '';
      const bValue = b.registrationId ?? '';
      return String(aValue).localeCompare(String(bValue), undefined, { numeric: true }) * direction;
    });
  }

  get pagedAdmissionList() {
    const start = (this.admissionPage - 1) * this.admissionPageSize;
    return this.sortedAdmissionList.slice(start, start + this.admissionPageSize);
  }

  goToAdmissionPage(page: number) {
    if (page < 1 || page > this.admissionTotalPages) {
      return;
    }
    this.admissionPage = page;
  }

  admissionCopyStatus: 'idle' | 'copied' = 'idle';
  private admissionExportHeaders = ['Student', 'Class', 'Date of Admission', 'Admission No', 'Father', 'Mother', 'Date of Birth', 'Phone'];

  private admissionExportRows() {
    return this.getNewAdmissionListArray.map(student => [
      student.studentName,
      `${student.classNumber}-${student.classDivision}`,
      student.dateOfAdmission,
      student.registrationId,
      student.parentName,
      student.motherName || '',
      student.dateOfBirth,
      student.mobileNumber
    ]);
  }

  // export currently loaded (all, not just current page) new-admission rows to Excel
  exportAdmissionsToExcel() {
    this.downloadTableAsExcel('Admissions', this.admissionExportHeaders, this.admissionExportRows());
  }

  // copy currently loaded new-admission rows to clipboard (tab-separated, pastes into Excel/Sheets)
  copyAdmissionsToClipboard() {
    const rows = this.admissionExportRows();
    const text = [this.admissionExportHeaders, ...rows]
      .map(row => row.map(cell => (cell === null || cell === undefined ? '' : String(cell))).join('\t'))
      .join('\n');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text);
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }

    this.admissionCopyStatus = 'copied';
    setTimeout(() => {
      this.admissionCopyStatus = 'idle';
    }, 1500);
  }

  private downloadTableAsExcel(fileName: string, headers: string[], rows: any[][]) {
    const escapeCell = (value: any) => `<td>${value === null || value === undefined ? '' : String(value)}</td>`;
    const headerRow = `<tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>`;
    const bodyRows = rows.map(row => `<tr>${row.map(escapeCell).join('')}</tr>`).join('');
    const table = `<table>${headerRow}${bodyRows}</table>`;
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head><meta charset="UTF-8"></head><body>${table}</body></html>`;
    const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.xls`;
    link.click();
    URL.revokeObjectURL(url);
  }

  // get admission list by date
  viewAdmissionByDate() {
    if (this.admissionDateFilter) {
      const parts = this.admissionDateFilter.split('-');
      this.getDateAdmission = ('' + parts[0] + '/' + parts[1] + '/' + parts[2]) as any;
    }
    this.getNewAdmissionList();
  }

  // get school activity status
  getSchoolActivityStatus() {
    if (!this.schoolActivityDataInCall) {
      this.schoolActivityDataInCall = true;
      this.getTodayDate();

      this.loaderactivity = true;
      this.getSchoolStatusListArray = [];
      this.dashboardservice.fetchSchoolActivity(this.getschoolStatusDate, this.getAuthToken)
        .subscribe(
          (data: any) => {
            for (let i = 0; i < data.length; i++) {
              this.getSchoolStatusListArray.push(data[i]);
              if (data.length - 1 === i) {
                this.loaderactivity = false;
                this.schoolActivityDataInCall = false;
              }
            }
            if (data.length === 0) {
              this.loaderactivity = false;
              this.schoolActivityDataInCall = false;
            }
            this.schoolStatusPage = 1;
          },
          error =>
            () => {
              this.schoolActivityDataInCall = false;
            }
        );
    }
  }

  get schoolStatusTotalPages() {
    return Math.max(1, Math.ceil(this.getSchoolStatusListArray.length / this.schoolStatusPageSize));
  }

  get pagedSchoolStatusList() {
    const start = (this.schoolStatusPage - 1) * this.schoolStatusPageSize;
    return this.getSchoolStatusListArray.slice(start, start + this.schoolStatusPageSize);
  }

  goToSchoolStatusPage(page: number) {
    if (page < 1 || page > this.schoolStatusTotalPages) {
      return;
    }
    this.schoolStatusPage = page;
  }

  // get school activity list by date
  viewSchoolActivityByDate() {
    if (this.schoolActivityDateFilter) {
      const a = this.schoolActivityDateFilter.split('-');
      this.getschoolStatusDate = '' + a[0] + '-' + a[1] + '-' + a[2];
    }
    this.getSchoolActivityStatus();
  }

  getProperNumber(num) {
    return num < 10 ? '0' + num : num;
  }

  getOnlineFeePayCollection(singleDate) {
    let date;
    let endDate;
    if (singleDate) {
      if (this.onlineFeeSingleDate) {
        const dr = this.onlineFeeSingleDate.split('-');
        date = dr[0] + '-' + dr[1] + '-' + dr[2];
        endDate = date;
      }
    } else {
      if (this.onlineFeeStartDate && this.onlineFeeEndDate) {
        const s2A = this.onlineFeeStartDate.split('-');
        const e2A = this.onlineFeeEndDate.split('-');
        date = s2A[0] + '-' + s2A[1] + '-' + s2A[2];
        endDate = e2A[0] + '-' + e2A[1] + '-' + e2A[2];
      } else {
        const d = new Date();
        date = d.getFullYear() + '-' + this.getProperNumber(d.getMonth()) + '-' + this.getProperNumber(d.getDate());
        endDate = date;
        this.onlineFeeSingleDate = date;
      }
    }

    this.dashboardservice.onlineFeeCollectionHistory(date, endDate, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.onlineFeeCollection = data;
        },
        error =>
          () => {
          }
      );
  }

  // view activity detail
  viewActivityDetail(getClassId, classNumber, classDivision, totalStudents, attendence, fessCollected,
    diaries, teacher1, teacher2, teacher3) {
    this.showActivityDetail = true;
    this.activityDetailTab = 'overview';
    const viewActivityClassId = getClassId;
    this.viewActivityClassNumber = classNumber;
    this.viewActivityClassSection = classDivision;
    this.viewActivityTotalStudent = totalStudents;
    this.viewActivityAttendence = attendence;
    this.viewActivityFeesCollected = fessCollected;
    this.viewActivityDiaries = diaries;
    this.viewActivityTeacher1 = teacher1;
    this.viewActivityTeacher2 = teacher2;
    this.viewActivityTeacher3 = teacher3;

    this.getTodayDate();

    this.getClassFeed(viewActivityClassId, this.getschoolStatusDate);
  }

  closeActivityDetail() {
    this.showActivityDetail = false;
  }

  // get feed for class
  getClassFeed(viewActivityClassId, getschoolStatusDate) {
    this.getgetClassFeedListArray = [];

    this.dashboardservice.fetchClassFeed(viewActivityClassId, getschoolStatusDate, this.getAuthToken)
      .subscribe(
        (data: any) => {
          if (data.length === 0) {
            this.feedCount = false;
          } else {
            this.feedCount = true;
            for (const item of data) {
              this.getgetClassFeedListArray.push(item);
            }
          }
        },
        error =>
          () => {
          }
      );
  }

  // get today date
  getTodayDate() {
    const getDateNow = new Date();
    const getMonth = getDateNow.getUTCMonth() + 1;
    const getDay = getDateNow.getUTCDate();
    const getYear = getDateNow.getUTCFullYear();

    this.todayDate = getYear + '/' + getMonth + '/' + getDay;
  }

  getDashboardData() {
    this.loaderMetrics = true;
    this.dashboardservice.fetchDashboardData(this.getSchoolId, DashboardV2Component.gAcademicId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          this.totalBroadcast = data.dashboardMetrices.totalBroadcast.toLocaleString('en');
          this.totalStudents = data.dashboardMetrices.totalStudent.toLocaleString('en');
          this.totalStaffs = data.dashboardMetrices.totalStaff.toLocaleString('en');
          this.totalClasses = data.dashboardMetrices.totalClass.toLocaleString('en');

          const activeStaffAppUserCount = Number(data.dashboardMetrices.ActiveStaffAppUser) || 0;
          const inActiveStaffAppUserCount = Number(data.dashboardMetrices.InActiveStaffAppUser) || 0;
          const activeParentAppUserCount = Number(data.dashboardMetrices.ActiveParentAppUser) || 0;
          const inActiveParentAppUserCount = Number(data.dashboardMetrices.InActiveParentAppUser) || 0;

          this.activeStaffAppUser = activeStaffAppUserCount;
          this.inActiveStaffAppUser = inActiveStaffAppUserCount;
          this.activeParentAppUser = activeParentAppUserCount;
          this.inActiveParentAppUser = inActiveParentAppUserCount;

          const staffAppTotal = activeStaffAppUserCount + inActiveStaffAppUserCount;
          const parentAppTotal = activeParentAppUserCount + inActiveParentAppUserCount;
          this.staffAppAdoptionPercent = staffAppTotal > 0 ? Math.round((activeStaffAppUserCount / staffAppTotal) * 100) : 0;
          this.parentAppAdoptionPercent = parentAppTotal > 0 ? Math.round((activeParentAppUserCount / parentAppTotal) * 100) : 0;

          this.parentAppAndroidVersion = data.dashboardMetrices.AndroidParentAppVersion;
          this.staffAppAndroidVersion = data.dashboardMetrices.AndroidStaffAppVersion;

          for (let i = 0; i < data.recentBroadcast.length; i++) {
            let message = decodeURIComponent(data.recentBroadcast[i].message);
            message = this.getWords(message, 5) + '.....';
            const createdTime = data.recentBroadcast[i].createdTime;
            const createdBy = data.recentBroadcast[i].createdBy;
            const approvedStatus = data.recentBroadcast[i].approvedStatus;
            if (approvedStatus === 0) {
              this.isApproved = false;
            } else if (approvedStatus === 1) {
              this.isApproved = true;
            }
            data.recentBroadcast[i] = {
              message,
              createdTime,
              createdBy,
              approvedStatus: this.isApproved
            };
            this.recentBroadcast.push(data.recentBroadcast[i]);
          }

          this.lengthRegStudentsArray = data.studentRegistration.length;
          this.totalRegStudents = this.totalStudents;
          for (let i = 0; i < this.lengthRegStudentsArray; i++) {
            if (data.studentRegistration[i].year !== 0 && data.studentRegistration[i].year !== null) {
              const coord1 = [];
              coord1.push(i + 1);
              coord1.push(data.studentRegistration[i].numberofstudents);

              const coord2 = [];
              coord2.push(i + 1);
              coord2.push(data.studentRegistration[i].year);

              this.studentRegistration.push(coord1);
              this.regTickValue.push(coord2);
            }
          }

          const a = data.studentRegistration[0].numberofstudents;
          const b = this.totalRegStudents - a;

          if (a > b) {
            this.regAverage = (b / a) * 100;
          } else if (a < b) {
            this.regAverage = (a / b) * 100;
          }
          this.regAverage = parseFloat(this.regAverage.toFixed(2));

          this.getAcademicData();
          this.loaderMetrics = false;
        },
        error => {
          this.loaderMetrics = false;
        }
      );
  }

  // get academic details
  getAcademicData() {
    this.dashboardservice.fetchAcademicList(this.getSchoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          for (const item of data.academicList) {
            if (item.InActive === 0) {
              DashboardV2Component.gAcademicId = item.pkAcademicId;
            }
          }
        },
        error => {
        }
      );
  }

  // string wrap to words function
  getWords(str, count) {
    return str.split(/\s+/).slice(0, count).join(' ');
  }

  // token auth
  isValidToken() {
    if (this.getAuthToken && this.getSchoolId) {
      localStorage.setItem('usertoken', this.getAuthToken);
      localStorage.setItem('schoolinfo', this.getSchoolId);
      localStorage.setItem('loginMode', this.loginMode);
      localStorage.setItem('adminType', this.adminType);
      localStorage.setItem('feesModuleSettings', this.feesModuleSettingsDetails);
      localStorage.setItem('currency', this.schoolCurrency);
      localStorage.setItem('isFranchise', this.isFranchise);
      localStorage.setItem('fkFranchiseId', this.fkFranchiseId);
      localStorage.setItem('adminPermissionlist', this.adminPermissionlist);
      localStorage.setItem('staffName', this.staffName);
      this.schoolCountryCode = this.schoolCountryCode.startsWith('+') ? this.schoolCountryCode.slice(1) : this.schoolCountryCode;
      localStorage.setItem('countryCode', this.schoolCountryCode);
      this.getDashboardData();
      this.getSchoolInfoFromHeader();
      this.getNewAdmissionList();
      this.getGroupsClassCategories(this.getSchoolId);
    } else if (this.loginMode === 'STAFF') {
      this.router.navigate(['/exams']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  initScripts() {
    this.scriptLoader.loadScript($, 'DASHBOARD');
  }

  ngOnInit() {
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('usertoken='));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    this.getAuthToken = tokenValue;
    const getSchoolIdDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('schoolinfo='));
    let getSchoolIdDetailsValue = getSchoolIdDetails ? getSchoolIdDetails.split('=')[1] : null;
    this.getSchoolId = getSchoolIdDetailsValue;
    const loginModeDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('loginMode='));
    let loginModeDetailsValue = loginModeDetails ? loginModeDetails.split('=')[1] : null;
    this.loginMode = loginModeDetailsValue;
    const adminTypeDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('adminType='));
    let adminTypeDetailsValue = adminTypeDetails ? adminTypeDetails.split('=')[1] : null;
    this.adminType = adminTypeDetailsValue;

    const schoolCurrencyDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('currency=')) || 'INR';
    let schoolCurrencyDetailsValue = schoolCurrencyDetails ? schoolCurrencyDetails.split('=')[1] : null;
    this.schoolCurrency = schoolCurrencyDetailsValue;

    const schoolCountryCodeDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('countryCode=')) || this.brandService.brand.defaultCountryDialCode || '91';
    let schoolCountryCodeDetailsValue = schoolCountryCodeDetails ? schoolCountryCodeDetails.split('=')[1] : null;
    this.schoolCountryCode = schoolCountryCodeDetailsValue;

    const isFranchiseDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('isFranchise='));
    let isFranchiseValue = isFranchiseDetails ? isFranchiseDetails.split('=')[1] : null;
    this.isFranchise = isFranchiseValue;

    const fkFranchiseIdDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('fkFranchiseId='));
    let fkFranchiseIdValue = fkFranchiseIdDetails ? fkFranchiseIdDetails.split('=')[1] : null;
    this.fkFranchiseId = fkFranchiseIdValue;
    const loginStaffName = document.cookie.split(';').find(cookie => cookie.trim().startsWith('staffName='));
    let staffNameValue = loginStaffName ? loginStaffName.split('=')[1] : null;
    this.staffName = staffNameValue;

    if (this.loginMode === 'STAFF') {
      this.router.navigate(['/exams']);
    }
    const adminPermissionlistDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('adminPermissionlist='));
    const adminPermissionlist = adminPermissionlistDetails ? adminPermissionlistDetails.split('=')[1] : null;
    this.adminPermissionlist = adminPermissionlist;

    if (adminPermissionlist) {
      const list = JSON.parse(adminPermissionlist);
      this.permissions = list;
    }
    let feesModuleSettings = [{ isFeesModuleEnable: '', SettingName: '' }];
    const feesModuleSettingsStoreDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('feesModuleSettings='));
    const feesModuleSettingsStore = feesModuleSettingsStoreDetails ? feesModuleSettingsStoreDetails.split('=')[1] : null;
    this.feesModuleSettingsDetails = feesModuleSettingsStore;
    if (feesModuleSettingsStore) {
      feesModuleSettings = JSON.parse(feesModuleSettingsStore);
      if (feesModuleSettings.length > 0) {
        let isOnlinePayEnabled = false;
        let isIndependentFeeEnabled = false;
        for (const setting of feesModuleSettings) {
          if (setting.isFeesModuleEnable === 'ENABLED' && setting.SettingName === 'ONLINE_PAYMENT_INDEPENDENT_TO_FEES_STRUCTURE') {
            isIndependentFeeEnabled = true;
          }
          if (setting.isFeesModuleEnable === 'ENABLED' && setting.SettingName === 'MOBILE_FEES_PAYMENT') {
            isOnlinePayEnabled = true;
          }
        }
        if (isIndependentFeeEnabled && isOnlinePayEnabled) {
          this.onlinePaymentHistory = 'ENABLED';
        } else {
          this.onlinePaymentHistory = 'DISABLED';
        }
      }
    }

    this.isValidToken();

    this.getNewAdmissionList();
    this.getSchoolActivityStatus();

    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getNewAdmissionList();
      this.getSchoolActivityStatus();
    });

    // pick initial tab based on the same permission gating as the legacy dashboard
    if (this.permissions.VIEW_NEW_ADMISSIONS !== 'ENABLED') {
      if (this.permissions.VIEW_SCHOOL_DAY_STATUS === 'ENABLED') {
        this.activeTab = 'schoolStatus';
      } else if (this.onlinePaymentHistory === 'ENABLED') {
        this.activeTab = 'onlinePayments';
      } else if (this.brand.appStatusTabEnabled) {
        this.activeTab = 'appStatus';
      }
    }
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  getGroupsClassCategories(schoolId) {
    this.schoolCategories = [];
    this.groupservice.groupsClassCategories(schoolId, this.getAuthToken)
      .subscribe(
        (data: any) => {
          for (let i = 0; i < data.schoolCategory.length; i++) {
            this.schoolCategories.push(data.schoolCategory[i]);
          }
        },
        error => {
        }
      );
  }

  getCategoryFunction(selectedCategoryId) {
    this.schoolClasses = [];
    this.schoolClassesSections = [];
    this.selectClassStatus = selectedCategoryId == 0;
    this.selectClassSectionStatus = true;
    this.selectedCategory = selectedCategoryId;
    this.selectedClass = '0';
    this.selectedSection = '0';
    this.getNewAdmissionList();
    if (selectedCategoryId != 0) {
      this.groupservice.groupsAvailableClass(this.getSchoolId, this.selectedCategory, this.getAuthToken)
        .subscribe(
          (data: any) => {
            for (const item of data.className) {
              this.schoolClasses.push(item);
            }
          },
          error => { }
        );
    }
  }

  selectClassFunction(selectedClassId) {
    this.selectedClass = selectedClassId;
    this.schoolClassesSections = [];
    this.selectClassSectionStatus = selectedClassId == 0;
    this.selectedSection = '0';
    this.getNewAdmissionList();
    if (selectedClassId != 0) {
      this.groupservice.groupsAvailableClassSection(this.selectedClass, this.getAuthToken)
        .subscribe(
          (data: any) => {
            for (const item of data) {
              this.schoolClassesSections.push(item);
            }
          },
          error => { }
        );
    }
  }

  selectSectionFunction(selectedSectionId) {
    this.selectedSection = selectedSectionId;
    this.getNewAdmissionList();
  }
}
